<template>
  <!-- 头部整体盒子 -->
  <div id="header" :class="['container-fuild', isNavFixed ? 'is-nav-fixed' : '', isNavDown ? 'is-nav-down' : '']">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs hidden-sm">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_black.png" @click="GoTop()" />
      </div>
      <!-- 导航内容 -->
      <div class="header-nav-right">
        <ul class="header-nav-wrapper">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" @mouseover="showDropDown(index)" @mouseout="hideDropDown">
            <template v-if="item.children.length > 0">
              <template v-if="item.name === 'base动向'">
                <router-link :to="item.path" class="name">
                  <span>base</span>动向
                </router-link>
              </template>
              <template v-else-if="item.name === '关于base'">
                <router-link :to="item.path" class="name">
                  关于<span>base</span>
                </router-link>
              </template>
              <template v-else-if="item.name === 'ESG策略与实践'">
                <router-link :to="item.path" class="name">
                  <span>ESG</span>
                </router-link>
              </template>
              <template v-else>
                <router-link :to="item.path" class="name">
                  {{ item.name }}
                </router-link>
              </template>
              <span class="nav-icon el-icon-caret-bottom" :class="item.sub ? 'nav-icon-active' : ''"></span>
            </template>
            <template v-else>
              <router-link :to="item.path">
                {{ item.name }}
              </router-link>
            </template>
            <dl v-show="item.sub" class="animated fadeIn">
              <dt v-for="(i, n) in item.children" :key="n">
                <template v-if="i.name === 'ESG践行'">
                  <router-link :to="i.path" :class="i.css"><span>ESG</span>践行</router-link>
                </template>
                <template v-else>
                  <router-link :to="i.path" :class="i.css">{{ i.name }}</router-link>
                </template>
              </dt>
            </dl>
          </li>
        </ul>
        <div class="changelan">
          <!-- <span class="lannow">CN</span> | <span @click="changeLanguage(1)">EN</span> -->
          <span class="lannow">CN</span> | <span @click="changeLanguage(1)">EN</span> | <span
            @click="changeLanguage(2)">JP</span>
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-sm visible-xs">
      <div class="header-nav-m-ct">
        <div class="header-nav-m-logo">
          <img class="center-block" src="@/assets/img/logo_black.png" alt="logo" @click="GoTop()" />
        </div>
        <div class="header-nav-m-icon" @click="nMenuClick">
          <img src="@/assets/img/header_menu_black.png" alt="" />
        </div>
      </div>
    </div>
    <div class="menu-expanded-bg visible-sm visible-xs" v-if="nMenvRight !== '-100%'" @click="nMenuClick"></div>
    <div class="menu-expanded visible-sm visible-xs" :style="{ right: nMenvRight }">
      <div class="m-ex-top">
        <!-- <div class="m-ex-logo">
          <img src="@/assets/img/logo_black.png" class="logo" />
        </div> -->
        <div class="m-ex-close" @click="nMenuClick">
          <img src="@/assets/img/header_menu_close.png" alt="" />
        </div>
      </div>
      <ul class="m-ex-el-nav">
        <section v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)" class="m-ex-item-container">
          <li class="m-ex-menu-item" :class="item.sub ? 'm-ex-menu-item-active' : ''">
            <template v-if="item.children.length > 0">
              <template v-if="item.name === 'base动向'">
                <a class="name" @click="showDropDown(index)"><span>base</span>动向</a>
              </template>
              <template v-else-if="item.name === '关于base'">
                <a class="name" @click="showDropDown(index)">关于<span>base</span></a>
              </template>
              <template v-else-if="item.name === 'ESG策略与实践'">
                <a class="name" @click="showDropDown(index)"><span>ESG</span>策略与实践</a>
              </template>
              <template v-else>
                <a class="name" @click="showDropDown(index)">{{ item.name }}</a>
              </template>
              <span class="nav-icon el-icon-caret-bottom" :class="item.sub ? 'nav-icon-active' : ''"></span>
            </template>
            <template v-else>
              <router-link :to="item.path">
                {{ item.name }}
              </router-link>
            </template>
            <dl v-show="item.sub" class="animated fadeIn">
              <template v-if="item.name === '服务公寓' || item.name === 'base动向' || item.name === 'ESG策略与实践'">
                <dt>
                  <router-link :to="item.path">全部</router-link>
                </dt>
              </template>
              <template v-if="item.name === '关于base'">
                <dt>
                  <router-link :to="item.path">关于<span>base</span></router-link>
                </dt>
              </template>
              <dt v-for="(i, n) in item.children" :key="n">
                <router-link :to="i.path" :class="i.css">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
        </section>
      </ul>
      <div class="changelan">
        <!-- <span class="lannow">CN</span> | <span @click="changeLanguage(1)">EN</span> -->
        <span class="lannow">CN</span> | <span @click="changeLanguage(1)">EN</span> | <span
          @click="changeLanguage(2)">JP</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      i: 0,
      isNavFixed: false,
      isNavDown: false,
      nMenvRight: "-100%",
      // navIndex: sessionStorage.getItem("navIndex")
      //   ? sessionStorage.getItem("navIndex")
      //   : 0,
      //navIndex: 0,
      menuName: "首页",
      menuClass: "el-icon-caret-bottom",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "服务公寓",
          path: "/apartment",
          sub: false,
          children: [{
            name: 'basePLUS',
            path: '/apartment?type=1',
            css: 'cssen'
          }, {
            name: 'base',
            path: '/apartment?type=2',
            css: 'cssen'
          }, {
            name: 'baseLITE',
            path: '/apartment?type=3',
            css: 'cssen'
          }],
        },
        {
          name: "安心入住",
          path: "/checkin",
          children: [],
        },
        {
          name: "base动向",
          path: "/trend",
          sub: false,
          children: [
            {
              name: '高光时刻',
              path: '/trend?type=1',
              css: ''
            }, {
              name: '精彩活动',
              path: '/trend?type=2',
              css: ''
            }, {
              name: '活动预告',
              path: '/trend?type=3',
              css: ''
            }
          ],
        },
        {
          name: "关于base",
          path: "/aboutus",
          sub: false,
          children: [{
            name: '加入我们',
            path: '/jobchance',
            css: ''
          },
          {
            name: '联系我们',
            path: '/contactus',
            css: ''
          }],
        },
        {
          name: "商务拓展",
          path: "/business",
          children: [],
        },
        {
          name: "ESG策略与实践",
          path: "/esg",
          sub: false,
          children: [
            {
              name: '环境建设',
              path: '/esg?type=1',
              css: ''
            }, {
              name: '社会建设',
              path: '/esg?type=2',
              css: ''
            }, {
              name: '公司治理',
              path: '/esg?type=3',
              css: ''
            }, {
              name: 'ESG践行',
              path: '/esg?type=4',
              css: ''
            }
          ],
        },
      ],
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },

  watch: {
    $route: {
      handler(to, from) {
        if (to != from) {
          this.nMenvRight = "-100%";
        }
        this.navList.map(item => item.sub = false);
      },
      immediate: true
    }
  },

  computed: {
    navIndex() {
      //console.log(this.$route.path)
      let that = this,
        _idx;
      if (that.$route.path === '/apartment/apadetail') {
        _idx = 1;
      } else if (that.$route.path === '/jobchance') {// || that.$route.path === '/business'
        _idx = 4;
      } else {
        _idx = that.navList.findIndex((item) => (item.path === that.$route.path));
      }
      return _idx
    }
  },

  methods: {
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
        document.body.scrollTop
      var scroll = scrollTop - this.i;
      this.i = scrollTop;
      if (scroll < 0) {
        this.isNavFixed = true;
        this.isNavDown = false;
      } else {
        this.isNavFixed = false;
        this.isNavDown = true;
      }
      if (this.i == 0) {
        this.isNavFixed = false;
        this.isNavDown = false;
      }
      //this.navList.map(item => item.sub = false)
    },

    navClick(index, name) {
      //this.navIndex = index;
      //sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },

    showDropDown(e) {
      this.navList.forEach((item, index) => {
        if (e === index) {
          if (item.sub) {
            item.sub = false;
          } else {
            item.sub = true;
          }
        } else {
          item.sub = false;
        }
      })
    },

    hideDropDown(e) {
      this.navList.map(item => item.sub = false)
    },

    menuClick() {
      if (this.menuClass == "el-icon-caret-bottom") {
        this.menuClass = "el-icon-caret-top";
      } else {
        this.menuClass = "el-icon-caret-bottom";
      }
    },
    nMenuClick() {
      if (this.nMenvRight == "-100%") {
        this.nMenvRight = "0";
      } else {
        this.nMenvRight = "-100%";
      }
    },

    changeLanguage(e) {
      //console.log(this.$route.fullPath)
      if (e === 1) {
        if (this.$route.fullPath === '/') {
          this.$router.push({ path: '/en' });
        } else {
          this.$router.push({ path: `/en${this.$route.fullPath}` });
        }
      } else {
        if (this.$route.fullPath === '/') {
          this.$router.push({ path: '/jp' });
        } else {
          this.$router.push({ path: `/jp${this.$route.fullPath}` });
        }
      }
    },

    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  },
};
</script>
<style lang="scss" scoped>
a {
  &:focus {
    text-decoration: none;
  }

  &:hover {
    text-decoration: none;
  }
}

/* 顶部 */
#header {
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 0.9);
  transition: all 1s;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;

  &.is-nav-fixed {
    position: fixed;
    z-index: 1001;
    background: #fff;
    box-shadow: 0 1px 10px 0 rgb(90 43 129 / 20%);
  }

  &.is-nav-down {
    top: -100%;
  }

  .header-nav {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &::before {
      display: none;
    }

    &::after {
      display: none;
    }

    .header-nav-logo {
      display: flex;
      cursor: pointer;

      img {
        max-width: 80px;
      }
    }

    .header-nav-right {
      display: flex;
      align-items: center;

      .header-nav-wrapper {
        margin: 0;
        display: flex;
        font-size: 14px;
        color: #272727;

        li {
          margin-left: 56px;
          position: relative;

          .name {
            cursor: pointer;

            &:hover {
              color: #3C5896;
            }
          }

          .nav-icon {
            transition: all .3s;

            &.nav-icon-active {
              &.el-icon-caret-bottom {
                transform: rotate(180deg);
              }
            }
          }


          >a {
            color: #272727;

            span {
              font-family: $FM6;
            }

            &:hover {
              color: #3C5896;
              text-decoration: none;
            }
          }

          dl {
            width: 100px;
            position: absolute;
            left: 50%;
            top: 90%;
            margin-left: -50px;
            padding-top: 10px;
            animation-duration: .5s;

            dt {
              width: 100px;
              height: 36px;
              background: rgba(255, 255, 255, 0.8);
              text-align: center;
              line-height: 36px;
              border-bottom: 1px solid #fff;

              &:last-child {
                border-bottom: none;
              }

              a {
                font-size: 14px;
                font-weight: normal;
                color: #272727;

                span {
                  font-family: $FM6;
                }

                &:hover {
                  color: #3C5896;
                }

                &.cssen {
                  font-family: $FM6;
                }
              }
            }
          }

          &.active {
            >a {
              color: #3C5896;
              font-weight: 700;
              border-bottom: 1px solid #3C5896;

              &:hover {
                text-decoration: none;
              }
            }
          }
        }
      }

      .changelan {
        margin-left: 56px;
        font-family: $FM6;

        span {
          font-size: 14px;
          font-weight: normal;
          color: #272727;
          cursor: pointer;

          &.lannow {
            text-decoration: underline;
            color: #3c5896;
            font-weight: 700;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 997px) {
  #header {
    background: none;
    height: 55px;
    position: fixed;

    &.is-nav-down {
      top: 0 !important;
    }

    &.is-nav-fixed {}
  }

  .header-nav-m {
    background: #fff;
    height: 55px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transition: all 0.5s;
    box-shadow: 0 1px 10px 0 rgb(90 43 129 / 20%);

    .header-nav-m-ct {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header-nav-m-logo {
        margin-left: 15px;

        img {
          max-width: 55px;
        }
      }

      .header-nav-m-icon {
        width: 26px;
        margin-right: 15px;

        img {
          width: 26px;
        }
      }
    }
  }

  .menu-expanded-bg {
    height: 100vh;
    width: 100%;
    z-index: 1640;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
  }

  .menu-expanded {
    overflow-y: auto;
    display: block;
    height: 100vh;
    width: 40%;
    padding: 24px 18px;
    position: fixed;
    top: 0;
    z-index: 1650;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.15s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    box-shadow: 0 2px 6px 2px hsl(194deg 8% 50% / 22%);

    .m-ex-top {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 36px;

      .m-ex-logo {
        img {
          max-width: 85px;
        }
      }

      .m-ex-close {
        img {
          max-width: 20px;
        }
      }
    }

    .m-ex-el-nav {
      list-style: none;
      position: relative;
      margin: 0;
      padding-left: 0;

      .m-ex-menu-item {
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        padding: 20px 0;
        letter-spacing: 0.4px;
        transition: all .5s;
        height: auto;

        .nav-icon {
          transition: all .3s;

          &.nav-icon-active {
            &.el-icon-caret-bottom {
              transform: rotate(180deg);
            }
          }
        }

        a {
          font-size: 12px;
          line-height: 18px;
          color: #272727;

          span {
            font-family: $FM6;
          }
        }

        dl {
          margin-top: 10px;
          margin-bottom: 0;
          font-size: 12px;

          dt {
            padding: 5px 0;

            a {
              font-size: 12px;

              &.cssen {
                font-family: $FM6;
              }
            }

          }
        }
      }
    }

    .changelan {
      padding-top: 20px;

      span {
        font-size: 14px;
        font-weight: normal;
        color: #272727;
        cursor: pointer;

        &.lannow {
          text-decoration: underline;
          color: #3c5896;
          font-weight: 700;
        }
      }
    }
  }
}

@media screen and (min-width: 998px) {
  #header {
    .header-nav {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}


@media screen and (min-width: 1200px) {
  #header {
    .header-nav {
      width: 1200px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}

@media screen and (min-width: 1679px) {}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue